import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!url || !anonKey) {
  const missing = [!url && 'VITE_SUPABASE_URL', !anonKey && 'VITE_SUPABASE_ANON_KEY']
    .filter(Boolean)
    .join(', ');
  const msg = `Missing env vars: ${missing}`;
  // eslint-disable-next-line no-console
  console.error('[supabase] ' + msg);
  if (typeof document !== 'undefined') {
    document.body.innerHTML = `
      <div style="
        font-family: system-ui, sans-serif;
        background: #0d1117; color: #e6e6e6;
        min-height: 100vh; display: flex; align-items: center; justify-content: center;
        padding: 24px; text-align: center;
      ">
        <div style="max-width: 520px;">
          <div style="font-size: 48px; margin-bottom: 16px;">⚙️</div>
          <h1 style="font-size: 20px; margin: 0 0 12px; color: #4a9eff;">Configuration error</h1>
          <p style="color: #888; line-height: 1.5; margin: 0 0 16px;">
            The app can't reach its backend because build-time environment variables are missing.
          </p>
          <code style="
            display: block; background: #161b22; border: 1px solid #2a2d35;
            padding: 10px 14px; border-radius: 8px; color: #e74c3c;
            font-size: 13px; margin-bottom: 16px;
          ">${missing}</code>
          <p style="color: #666; font-size: 12px; margin: 0;">
            Set these in Vercel → Project Settings → Environment Variables, then redeploy.
          </p>
        </div>
      </div>`;
  }
  throw new Error(msg);
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Bypass navigator.locks. In supabase-js v2.45, getSession() acquires a
    // Web Lock to serialize auth ops across tabs. If a prior page crashed or
    // a service worker held the scope, the lock never releases and
    // getSession() hangs forever — producing our "[auth] getSession timed out"
    // symptom on hard refresh. We don't have multi-tab auth flows that need
    // strict serialization, so a pass-through function is safe.
    lock: async (_name, _acquireTimeout, fn) => fn(),
  },
});
